import { Injectable } from '@angular/core';
import { EmailModels } from 'models/email.models';

import { Observable, from as fromPromise } from 'rxjs';
import { map } from 'rxjs/operators';

const TEMPLATE_PATH_FORMAT = 'assets/templates/template_{0}.txt';
const SUBJECTS = {
  [EmailModels.EmailTemplateEnum.Open]:
    "Votre demande d'ouverture de code Courtier TunnelSante",
  [EmailModels.EmailTemplateEnum.Unpaid]: 'Impayé',
  [EmailModels.EmailTemplateEnum.AcceptationSansEffet]: 'Sans effet recevable',
  [EmailModels.EmailTemplateEnum.RefusSansEffet]: 'Refus de sans effet',
};

@Injectable({
  providedIn: 'root',
})
export class EmailTemplateService {
  private getEmailTemplate(
    type: EmailModels.EmailTemplateEnum,
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', TEMPLATE_PATH_FORMAT.format(+type));

      xhr.addEventListener('readystatechange', () => {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
          resolve(xhr.responseText);
        } else if (xhr.readyState === XMLHttpRequest.DONE) {
          reject();
        }
      });

      xhr.send(null);
    });
  }

  public getEmailData(
    type: EmailModels.EmailTemplateEnum,
  ): Observable<EmailModels.EmailTemplateData> {
    return fromPromise(this.getEmailTemplate(type)).pipe(
      map((body) => {
        return {
          subject: SUBJECTS[type],
          body: body,
        };
      }),
    );
  }
}
